import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-row-dashed align-middle mb-0" }
const _hoisted_5 = { class: "text-muted fw-bold w-200px" }
const _hoisted_6 = { class: "text-gray-900 text-break" }

import { computed, ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import { PaymentInfoStatusTypes } from "@/core/types/PaymentTypes";
import UserImageDoc from "@/projects/tenant/modules/users/components/UserImageDoc.vue";
import { useI18n } from "vue-i18n";

type WithdrawalPaymentInfo = {
  guid?: string;
  name?: string;
  status?: string | number;
  returnUrl?: string;
  walletAddress?: string;
  [key: string]: unknown;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawalPaymentInfoVerify',
  props: {
    approveHandler: { type: Function },
    rejectHandler: { type: Function }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const { t } = useI18n();
const modalFormRef = ref<InstanceType<typeof SimpleForm>>();
const withdrawalId = ref<number | null>(null);
const paymentInfo = ref<WithdrawalPaymentInfo>({});

const paymentInfoStatusLabels: Record<number, string> = {
  [PaymentInfoStatusTypes.pass]: "Pass",
  [PaymentInfoStatusTypes.tradeAccountVerify]: "Trade Account Verify",
  [PaymentInfoStatusTypes.walletVerify]: "Wallet Verify",
  [PaymentInfoStatusTypes.waitingForVerfied]: "Waiting For Verfied",
  [PaymentInfoStatusTypes.verfied]: "Verfied",
  [PaymentInfoStatusTypes.verifyFailed]: "Verify Failed",
  [PaymentInfoStatusTypes.tradeAccountVerified]: "Trade Account Verified",
  [PaymentInfoStatusTypes.walletVerified]: "Wallet Verified",
  [PaymentInfoStatusTypes.tradeAccountVerifiedFailed]:
    "Trade Account Verify Failed",
  [PaymentInfoStatusTypes.walletVerfiedFailed]: "Wallet Verify Failed",
};

const hiddenPaymentInfoFields = [
  "guid",
  "hashid",
  "platformtype",
  "playtformtype",
  "returnurl",
];

const statusText = computed(() => {
  const status = Number(paymentInfo.value.status);
  return paymentInfoStatusLabels[status] ?? paymentInfo.value.status ?? "";
});

const paymentInfoFieldLabels = computed<Record<string, string>>(() => ({
  name: t("fields.name"),
  status: t("fields.status"),
  walletAddress: t("fields.walletAddress"),
}));

const paymentInfoRows = computed(() =>
  Object.entries(paymentInfo.value)
    .filter(([key]) => !hiddenPaymentInfoFields.includes(key.toLowerCase()))
    .map(([key, value]) => ({
      label: paymentInfoFieldLabels.value[key] ?? key,
      value: key === "status" ? statusText.value : value,
    }))
    .filter(
      (row) => row.value !== undefined && row.value !== null && row.value !== ""
    )
);

const paymentInfoMedia = computed(() => ({
  guid: paymentInfo.value.guid,
  fileName: paymentInfo.value.guid,
}));

const approve = () => {
  if (withdrawalId.value === null) return;
  props.approveHandler(withdrawalId.value);
};

const reject = () => {
  if (withdrawalId.value === null) return;
  props.rejectHandler(withdrawalId.value);
};

__expose({
  show(id: number, info: WithdrawalPaymentInfo) {
    withdrawalId.value = id;
    paymentInfo.value = info;
    modalFormRef.value?.show();
  },
  hide() {
    modalFormRef.value?.hide();
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalFormRef",
    ref: modalFormRef,
    title: _ctx.$t('fields.paymentInfo'),
    "is-loading": false,
    submit: approve,
    discard: reject,
    "save-title": _ctx.$t('action.approve'),
    "discard-title": _ctx.$t('action.reject'),
    "submit-color": "primary",
    "discard-color": "danger",
    width: 720
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (paymentInfo.value.guid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(UserImageDoc, {
                media: paymentInfoMedia.value,
                "disabled-action": "",
                "can-verify-document": false
              }, null, 8, ["media"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentInfoRows.value, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.label
                }, [
                  _createElementVNode("th", _hoisted_5, _toDisplayString(row.label), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(row.value), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "save-title", "discard-title"]))
}
}

})